import React from 'react';
import { Account, ExternalSource } from '~/types';
import CloseAccountButton from './AccountActionButtons/CloseAccountButton';
import UnunblockAccountButton from './AccountActionButtons/UnblockAccountButton';
import BlockAccountButton from './AccountActionButtons/BlockAccountButton';
import { useAccountPermissions } from '~/hooks/accounts';

interface Props {
  record: Account | ExternalSource;
  status: 'ACTIVE' | 'BLOCKED' | 'CLOSED';
  refetch: () => void;
  resource?: 'accounts';
}

const AccountsActions = (props: Props) => {
  const { status, resource, record, refetch } = props;
  const { hasBlockPermission, hasUnblockPermission, hasClosePermission } = useAccountPermissions(
    'accounts',
    resource
  );
  if (!resource) return null;
  return (
    <>
      {status === 'ACTIVE' && hasBlockPermission && (
        <BlockAccountButton record={record} refetch={refetch} resource={resource} />
      )}
      {status === 'BLOCKED' && hasUnblockPermission && (
        <UnunblockAccountButton record={record} refetch={refetch} resource={resource} />
      )}
      {status !== 'CLOSED' && hasClosePermission && (
        <CloseAccountButton record={record} refetch={refetch} resource={resource} />
      )}
    </>
  );
};

export default AccountsActions;
